import { render } from "./DateChooser.vue?vue&type=template&id=cf5989e4"
import script from "./DateChooser.vue?vue&type=script&lang=js"
export * from "./DateChooser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__